/**
 * Home scene
 * 
 * @author Mautilus s.r.o.
 * @class Scene_Home
 * @extends Scene
 */

Scene_Home = (function (Scene) {

	var Scene_Home = function () {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Scene_Home.prototype, Scene.prototype, {
		/**
		 * @inheritdoc Scene#init
		 */
		init: function () {
			console.log('[Scene] init ' + this.name + ' scene');
			this.carouselImagesLoaded = false;
			this.smallCarouselsImagesLoaded = false;
			this.dontRedraw = false; // prevent to redraw scene

			/* Collections */
			this.bigCarouselColl = new Collection_Plays(null, {
				model: Model_Play,
				reqParams: {
				}
			});

			// big carousel
			this.carousel = '.featured-big';
			this.$carousel = $(this.carousel, this.$el);

			// small carousels
			this.categoriesList = new Collection_Categories(null, {
				model: Model_Category,
				reqParams: {
				}
			});

			this.smallCarouselsGrid = '.featured-carousels-grid';
			this.$smallCarouselsGrid = $(this.smallCarouselsGrid, this.$el);

			this.carouselActivated = false;

			this.$upArrow = this.$el.find('.nav-up');
			this.$downArrow = this.$el.find('.nav-down');

			this.$focusBlockers = this.$el.find('.focus-blocker');

			this.wrapper = this.$el.find('#scene-home-wrapper')[0];
		},

		/**
		 * @inheritdoc Scene#create
		 */
		create: function () {
			return $('#scene-home');
		},

		refresh: function () {
			this.activate()
				.bind(this)
				.then(function () {
					this.render();
					this.focus();
				})
				.catch(function (err) {
					console.error(err);
				});
		},

		/**
		 * @inheritdoc Scene#activate
		 */
		activate: function (config) {
			if(config) {
				this.dontRedraw = !config.redraw;
				this.setTopPosition(401);	// hard set value took from move() function
			}
			App.throbber();
			return new Promise(function (resolve, reject) {

				// webOS workaround return button
				// if (Main.device[0] === 'webos') {
				// 	Device.clearHistory();
				// }

				if (!this.dontRedraw) {
					var homeFetches = [];
					homeFetches.push(this.bigCarouselColl.fetch(), this.categoriesList.fetch());  // large carousel

					Promise.all(homeFetches)
						.bind(this)
						.then(function() {
							return this.carouselRender();
						})
						.then(function() {
							return this.categoriesListRender();
						})
						.then(function (resp) {
							App.splashscreenHide().then(function () {
								App.throbberHide();
							})					
							resolve();
						}, function (err) {
							console.error(err)
							App.splashscreenHide().then(function () {
								App.throbberHide();
							})
							App.trigger('error', __('err_data_fetch'));  // in parseProgress() for example
							reject(err);
						})
						.catch(function (err) {
							console.error(err);
							reject(err);
						});

				} else {
					App.throbberHide();
					resolve();
				}

			}.bind(this));
		},

		/**
		 * @inheritdoc Scene#deactivate
		 */
		deactivate: function () {
			// clear ul classes
			$('.movies ul', this.$el)
				.removeClass('left')
				.removeClass('left-sec')
				.removeClass('left-init')
				.removeClass('right')
				.removeClass('right-sec');
		},

		carouselRender: function () {
			// empty html blocks
			this.$carousel.empty();

			if (!this.carouselActivated) {
				/* Carousel Snippet */
				this.carousel = new Snippet_Carousel(this, {
					'target': this.$carousel,
					'collection': this.bigCarouselColl,
					'assetsVisible': 3,
					'assetsFocusableArray': [0, 1, 0],
					'neverEnding': true,
					'maxItems': 0
				});
				this.carousel.on('focus:out', this.onFocusOut, this);
			}
			return new Promise(function(resolve, reject) {
				this.carousel.render();
				if (this.carouselImagesLoaded) {
					resolve();
				} else 
					this.carousel.on('imagesloaded', function() {
						this.carouselImagesLoaded = true;
						resolve();
					}.bind(this));
			}.bind(this));
			
		},
		categoriesListRender: function () {
			this.$smallCarouselsGrid.empty();
			/* Carousel Snippet */
			this.smallCarouselsGrid = new Snippet_CarouselsGrid(this, {
				'el': '#scene-home .featured-carousels-grid',
				'snippet': Snippet_Slider,
				'classToAdd': 'featured-small',
				'categories': this.categoriesList,
				'assetsVisible': 4,
				'assetsFocusableArray': [0, 1, 1, 1, 1, 0],
				'neverEnding': false,
				'randomly': false,
				'maxItems': 0
			});
			return new Promise(function(resolve, reject) {
				this.smallCarouselsGrid.off('focus:out');
				this.smallCarouselsGrid.on('focus:out', this.onFocusOut, this);
				this.smallCarouselsGrid.render();
				if(this.smallCarouselsImagesLoaded) {
					resolve();
				}
				this.smallCarouselsGrid.on('imagesloaded', function() {
					this.smallCarouselsImagesLoaded = true;
					resolve();
				}.bind(this));
			}.bind(this));
		},

		signSnippetRender: function() {
			if (!this.signSnippet)
				this.signSnippet = new Snippet_Sign(this, {
					$el: $('#snippet-sign')
				});
			this.signSnippet.off('focus:out');			
			this.signSnippet.on('focus:out', this.onFocusOut, this);
			this.signSnippet.render();
		},
		/**
		 * @inheritdoc Scene#render
		 */
		render: function () {
			if (!this.dontRedraw) {
				this.resetPosition();
				this.signSnippetRender();
				if (!this.carouselActivated) {

					this.categoriesListRender();

				}
				this.carouselActivated = true;	
				this.dontRedraw = true;
			}
		},

		onLangChange: function () { },

		/**
		 * Calls onReturn() on focused element
		 * @inheritdoc Scene#onReturn
		 */
		onReturn: function ($el, event) {
			if (Focus.focused.belongsTo(this.smallCarouselsGrid.$el) && this.carousel.isFocusable()) {
				this.carousel.focus();
			} else if (Device.isWEBOS) {
				Device.openWebOSSmartHub();	// on webos we dont show exit dialog, we open the smart menu
			} else if (!App.dialog) {
				var exitDialog = new Snippet_Dialog_exit(null, {
					'selector': 'dialog-exit'
				});
				exitDialog.render();
			} else {
				App.dialog.onClose();
			}
			return false;
		},

		onClick: function ($el) {
			var direction = '';
			if (!$el.hasClass('hide'))
				direction = $el.attr('data-id');

			if (direction === 'down' || direction === 'up') {
				if (Focus.focused.belongsTo(this.smallCarouselsGrid.$el)) {
					this.smallCarouselsGrid.getFocusedRow().navigate(direction);
				} else if (Focus.focused.belongsTo(this.carousel.$el)) {
					this.carousel.navigate(direction);
				} else if(Focus.focused.belongsTo(this.signSnippet.$el)) {
					this.signSnippet.navigate('down');			
				}

				return false;
			} else {
				if (this.trigger('click', $el, event) === false) {
					return false;
				}
				return this.onEnter.apply(this, arguments);
			}
		},

		/**
		 * @inheritdoc Scene#focus
		 */
		focus: function (from_dir) {
			if (App.dialog) return false;

			if (from_dir == 'up') {
				return this.smallCarouselsGrid.focus() || this.carousel.focus();
			} else if (from_dir == 'down') {
				if (!this.actualRowIndex) {
					return this.carousel.focus() || this.smallCarouselsGrid.focus();
				} else {
					return this.smallCarouselsGrid.focus() || this.carousel.focus();
				}
			} else if (this.$lastFocused) {
				return Focus.to(this.$lastFocused);
			} else {
				return this.carousel.focus() || this.smallCarouselsGrid.focus();
			}
		},

		/**
		 * Manage the process of Focus delegation between snippets inside Scene
		 * 
		 * @param {Object} Snippet or jQuery
		 * @param {String} direction of Focus delegation
		 */
		onFocusOut: function (snippet, direction) {
			if(snippet === this.signSnippet) return this.carousel.focus();
			if (snippet === this.carousel) {
				if (direction === 'down') {
					if (this.smallCarouselsGrid.isFocusable()) {
						this.setFocusBlockers('scrolled');
						if (this.actualRowIndex)
							return this.smallCarouselsGrid.focus(this.actualRowIndex)
						return this.smallCarouselsGrid.focus();
					} else {
						return this.smallCarouselsGrid.focus(this.actualRowIndex);
					}
				} else if (direction === 'up') {
					this.carousel.$el.addClass('sign-focus');
					return this.signSnippet.focus();
				}
			} else if (snippet === this.smallCarouselsGrid) {
				if (direction === 'up') {
					if (this.carousel.isFocusable()) {
						this.smallCarouselsGrid.getFocusedRow().showArrows(false);
						this.resetFocusBlockers();
						this.hideUpArrow();
						return this.carousel.focus();
					}
				} else if (direction === 'down') {
					this.hideDownArrow();
					return false
				}
			}
		},

		/**
		 * @inheritdoc Scene#onBeforeGoBack
		 */
		onBeforeGoBack: function (fromScene) {
		},

		move: function (direction, indexOfRowInGrid) {
			return new Promise(function (resolve, reject) {

				// TODO: get scroll heights from styles
				var smallCarouselInitTop = 401,
					smallCarouselsLength = this.smallCarouselsGrid.config.categories.length;


				// when scroll down is requested
				if (direction === 1) {
					// if not comming from carousels grid and scene top position is in initial position
					if (typeof indexOfRowInGrid === 'undefined' && this.actualRowIndex === 0) {
						// move to first row of carousels grid
						this.showUpArrow();
						resolve();
					}
					// if coming from carousels grid and actual scroll step is lower than number of rows on home scene
					else if (typeof indexOfRowInGrid === 'number' && this.actualRowIndex <= smallCarouselsLength - 2) {
						this.showUpArrow();						
						this.setTopPosition(smallCarouselInitTop -  ++this.actualRowIndex * 230);
						this.smallCarouselsGrid.focus(this.actualRowIndex);
						if (this.actualRowIndex === smallCarouselsLength - 1) {
							this.hideDownArrow();
							this.setFocusBlockers('end');
						}
					}
				}
				// when scroll up is requested
				else if (direction === -1) {
					// if not comming from carousels grid and scene top position is going to initial position
					if (typeof indexOfRowInGrid === 'undefined' && this.actualRowIndex === 0) {
						this.actualRowIndex = 0;
						resolve();
					}
					// if comming from carousels grid and actual scroll step is lower than number of rows on home scene
					else if (typeof indexOfRowInGrid === 'number' && this.actualRowIndex <= this.smallCarouselsGrid.config.categories.length - 1) {
						if (this.actualRowIndex === this.smallCarouselsGrid.config.categories.length - 1) {
							this.setFocusBlockers('scrolled');
							this.showDownArrow();
						}
						this.setTopPosition(smallCarouselInitTop - --this.actualRowIndex * 230);
						this.smallCarouselsGrid.focus(this.actualRowIndex);						
					}
				}

			}.bind(this));
		},

		setTopPosition: function (distance) {
			this.smallCarouselsGrid.$el[0].style.top = distance + 'px';
		},

		showDownArrow: function () {
			this.$downArrow.removeClass('hide');
		},

		hideDownArrow: function () {
			this.$downArrow.addClass('hide');
		},

		showUpArrow: function () {
			this.$upArrow.removeClass('hide');
		},

		hideUpArrow: function () {
			this.$upArrow.addClass('hide');
		},

		resetPosition: function () {
			// this.setTopPosition(0);
			this.$lastFocused = null;
			this.actualRowIndex = 0;
			this.hideUpArrow();
			this.resetFocusBlockers();


			if (typeof this.smallCarouselsGrid === 'object') {
				this.smallCarouselsGrid.resetPosition();
				if (this.smallCarouselsGrid.isFocusable()) {
					this.showDownArrow();
				}
			}
		},

		resetFocusBlockers: function () {
			this.$focusBlockers.removeClass('scrolled end');
		},

		setFocusBlockers: function (classToApply) {
			this.resetFocusBlockers();
			this.$focusBlockers.addClass(classToApply);
		}
	});

	return Scene_Home;

})(Scene);



//////////////////
// WEBPACK FOOTER
// ./js/scene/home.js
// module id = 55
// module chunks = 0